/**
 * energy-surcharge-cleanup.js
 *
 * Removes the energy surcharge trigger variant from the cart when it is
 * the only remaining item (i.e. all real products have been removed).
 *
 * The Checkout UI Extension adds the trigger variant when checkout opens.
 * Without this cleanup, removing all real products from the cart drawer
 * leaves the $0 "Energy Surcharge" line sitting alone in the cart.
 *
 * Config is injected by snippets/energy-surcharge-cleanup.liquid.
 */

(() => {
  const el = document.getElementById('energy-surcharge-cleanup-data');
  if (!el) return;

  let triggerVariantId;
  try {
    ({ triggerVariantId } = JSON.parse(el.textContent));
  } catch {
    return;
  }

  if (!triggerVariantId) return;

  async function cleanupIfAlone() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      const items = cart.items ?? [];

      // Find the trigger line
      const triggerIdx = items.findIndex((item) => item.variant_id === triggerVariantId);
      if (triggerIdx === -1) return; // not in cart, nothing to do

      // Check if it's the only item
      const realItems = items.filter((item) => item.variant_id !== triggerVariantId);
      if (realItems.length > 0) return; // real products still present

      // Only the surcharge line remains — remove it
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: triggerIdx + 1, quantity: 0 }),
      });

      // Notify the theme to refresh the cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch {
      // Non-fatal — cart will reconcile at next checkout open
    }
  }

  // Run on page load
  cleanupIfAlone();

  // Run whenever the cart changes
  ['cart:updated', 'cart:item-removed'].forEach((name) => {
    document.addEventListener(name, cleanupIfAlone);
  });
})();
